import React, { useContext, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import './CurrentTasks.css';
import LeftColumn from '../MainPage/LeftColumn/LeftColumn';
import TaskCard from '../App/Common/Cards/TaskCard/TaskCard';
import CurrentTasksBlock from './CurrentTasksBlock';

import api from '../../Utils/Api';

import { CurrentUserContext } from '../../Contexts/CurrentUserContext';
import { JourneyContext } from '../../Contexts/JourneyContext'
import TableTests from '../Performance/Tables/TableTests/TableTests';
import LockedTaskCard from '../App/Common/Cards/LockedTaskCard/LockedTaskCard';
import Calendar from '../Calendar/Calendar';


const CurrentTasks = ({ courses }) => {
    const { token } = useContext(CurrentUserContext);
    const { currentPlace, breadCrumbs, setBreadCrumbs, setCurrentPlace } = useContext(JourneyContext)

    const [tab, setTab] = useState(false)
  const [titleTag, setTitle] = useState('')
    const [pendingCourses, setPendingCourses] = useState(undefined)
    const [isCoursesOpened, setIsCoursesOpened] = useState(false)
    const [selectedCourses, setSelectedCourses] = useState([])
    const [selectedCoursesIds, setSelectedCoursesIds] = useState([])
    const [tasks, setTasks] = useState([])

    const extractTests = (course) => {
      if (!course?.roadMap?.topics) return [];
      
      return course.roadMap.topics.flatMap((topic) => 
        topic?.lessons.flatMap((lesson) => 
          lesson?.steps.flatMap((step) => {
            if (step.type === 'test') {
              // console.log(step?.test);
              return step?.test ? [{...step.test, type: 'test', course: course}] : [];
            } else if (step.type === 'exercise') {
              return step?.exercise ? [{...step.exercise, type: 'exercise', course: course}] : [];
            }
            return [];
          })
        )
      );
    };
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
      const fetchDataTasks = async () => {
        try {
            setCurrentPlace({ title: 'Актуальные задания' });
            
            const tasksResponse = await api.getReportTasks(token);  // Await the API call
            setTasks(tasksResponse);
        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);  // Set loading to false after the data is fetched
        }
    };

    fetchDataTasks();
      // api.getReportTasks(token).then((res) => {
      //   // console.log(res)
      //   setTasks(res)
      // })
      const fetchData = async () => {
        try {
          setCurrentPlace({ title: 'Актуальные задания' });
          const courses = await api.getCourses(token);
          setPendingCourses(courses);
          // console.log(courses);
          
          for (const course of courses) {
            try {
              const roadMap = await api.getRoadMap(token, course.id);
              // console.log(roadMap);
              
              setPendingCourses((prevCourses) => {
                return prevCourses.map((prevCourse) => {
                  if (prevCourse.id === course.id) {
                    return { ...prevCourse, roadMap };
                  }
                  return prevCourse;
                });
              });
              const tests = extractTests({ ...course, roadMap });
            } catch (e) {
              console.log(e);
            }
          }
        } catch (e) {
          console.log(e);
        }
      };
    
      fetchData();
    }, []);

// console.log(pendingCourses)

    const checkBox = () => {
        let checkedBoxes = document.querySelectorAll('input:checked')
        // console.log(checkedBoxes)
        let checkedBoxesArray = Array.prototype.slice.call(checkedBoxes)

        let checkedOptionsIds = checkedBoxesArray.map(i => Number(i.id))
      //  console.log(checkedOptionsIds)
        setSelectedCoursesIds(checkedOptionsIds)
        // console.log(pendingCourses)
        const filteredCourses = tasks.filter(i => checkedOptionsIds.includes(i.course_id))
      //  console.log(filteredCourses)
        setSelectedCourses(filteredCourses)

    }
   // console.log(pendingCourses)

   const handleOpenTab = (title) => {
    if (title === 'Все курсы') {
        setTab(false)
        setTitle('_courses')
    } else if (title === 'Календарь') {
        setTab(true)
        setTitle('_calendar') 
    }
  }
  // console.log(tasks)
  // console.log(pendingCourses)
  console.log(selectedCourses);
  
    return (
        tasks && courses &&
        <div className='currentTasks__container'>
           <div className='tab__wrap'>
              <div className={'tab__btn' + (titleTag ? titleTag === '_courses' : 'true')} onClick={() => handleOpenTab('Все курсы')}>Все задания</div>
              {/* <div className={'tab__btn' + (titleTag ? titleTag === '_calendar' : 'false')} onClick={() => handleOpenTab('Календарь')}>Календарь</div> */}
            </div>
            {/* <LeftColumn courses={courses} /> */}
            {tab && <div className='courses__calendar'><Calendar></Calendar></div>}

            {!tab && <div className='openedBlock__container'>
           
            <div className='currentTasks__center' style={{padding: 0}}>
            
                <div className='currentTasks__top'>
                    {/* <div className='performance__navTree'>
                    <Link to={'/'}>  <div >Главная</div> </Link>
                        <div className='current'>Актуальные задания</div>
                    </div> */}

                    <div className='performance__filters'>
                        <div className='performance__courses' onClick={() => { setIsCoursesOpened(!isCoursesOpened); }}>
                            Курсы
                            {isCoursesOpened &&
                                <div className='filterMenu'>
                                    <div className='filterMenu__option'>
                                        <input type="checkbox" className="custom-checkbox" name="courseFilter" onChange={() => { setSelectedCourses([]); setSelectedCoursesIds([]) }} checked={!selectedCoursesIds.length > 0} />
                                        <label htmlFor="courseFilter">Все предметы</label>
                                    </div>
                                    {
                                    tasks.map((i, index) => {
                                      // console.log(i)
                                        return (
                                        <div key={index} className='filterMenu__option' onClick={(e) => { e.stopPropagation() }}>
                                            <input id={i.course_id} type="checkbox" className="custom-checkbox" name="courseFilter" onChange={() => { checkBox(); }} onClick={(e) => { e.stopPropagation() }} defaultChecked={selectedCoursesIds.includes(i.course_id)} />
                                            <label htmlFor="courseFilter">{i.course_title}</label>
                                        </div>
                                    )})}
                                </div>
                            }</div>
                        {/* <div className='performance__themes'>Темы</div>
                        <div className='performance__lessons'>Уроки</div> */}
                     </div>
                </div>
                <div className='currentTasks__tasks'>
                  {/* {tasks} */}
                 {/* {selectedCourses.length > 0 ? <TableTests data={selectedCourses}></TableTests> :
                 }  */}
                 {selectedCourses.length > 0 ? 
                  <TableTests data={selectedCourses} isLoading={isLoading}></TableTests>
                  : 
                  <TableTests data={tasks} isLoading={isLoading}></TableTests>
                  }
                  {/* <TableTests data={tasks}></TableTests> */}
                  {/* <TableTests key={selectedCourses.length > 0 ? 'selectedCourses' : 'allTasks'} data={selectedCourses.length > 0 ? selectedCourses : tasks} /> */}

                </div>
            </div>
            </div>}
            </div>


    )
}
export default CurrentTasks
